export enum CredentialNotificationType {
	DAYS_90 = 90,
	DAYS_60 = 60,
	DAYS_30 = 30,
	DAYS_14 = 14,
	DAYS_7 = 7,
	DAY_BEFORE = 1,
	EXPIRED = 0,
}

export const CredentialNotificationTypeMap = {
	90: CredentialNotificationType.DAYS_90,
	60: CredentialNotificationType.DAYS_60,
	30: CredentialNotificationType.DAYS_30,
	14: CredentialNotificationType.DAYS_14,
	7: CredentialNotificationType.DAYS_7,
	1: CredentialNotificationType.DAY_BEFORE,
	0: CredentialNotificationType.EXPIRED,
};

export const CredentialNotificationTypeLabel = {
	[CredentialNotificationType.DAYS_90]: '90d',
	[CredentialNotificationType.DAYS_60]: '60d',
	[CredentialNotificationType.DAYS_30]: '30d',
	[CredentialNotificationType.DAYS_14]: '14d',
	[CredentialNotificationType.DAYS_7]: '7d',
	[CredentialNotificationType.DAY_BEFORE]: '1d',
	[CredentialNotificationType.EXPIRED]: 'Daily',
};

export const CredentialNotificationTypeValues = Object.values(CredentialNotificationType)
	.filter((value): value is number => typeof value === 'number')
	.sort((a, b) => b - a);

export const CredentialNotificationTypeValuesMap: { [days: number]: true; } = Object.values(CredentialNotificationType).reduce((_acc, _type) => {
	_acc[_type] = true;
	return _acc;
}, {});
